import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Clipboard } from "@angular/cdk/clipboard";

import type { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";

import { driveFileUrlFromId } from "@dis/gapi";

@Component({
  selector: "copy-link-cell-renderer",
  imports: [MatIconModule],
  template: `
    @if (fileUrl) {
      <button
        type="button"
        class="copy-link-button"
        aria-label="Copy link to clipboard"
        (click)="copyLink($event)"
      >
        <mat-icon aria-label="copy link icon">content_copy</mat-icon>
      </button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .copy-link-button {
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: inherit;
      }
    `,
  ],
})
export class CopyLinkCellRenderer implements ICellRendererAngularComp {
  public fileUrl: string = "";

  #clipboard = inject(Clipboard);
  #snackBar = inject(MatSnackBar);

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const fileId = params.value;
    if (fileId) {
      this.fileUrl = driveFileUrlFromId(fileId);
    }
    return true;
  }

  copyLink(event: MouseEvent): void {
    event.stopPropagation();
    this.#clipboard.copy(this.fileUrl);
    this.#snackBar.open("Link copied", "", { duration: 2000 });
  }
}
